var map = {
	"./status-late.svg": "006c",
	"./status0.svg": "cd12",
	"./status1.svg": "b4e6",
	"./status2.svg": "fae1",
	"./status3.svg": "256d",
	"./status4.svg": "6b08",
	"./status5.svg": "85e5",
	"./status6.svg": "f68e",
	"./status7-1.svg": "a332",
	"./status7.svg": "4b96"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "26a4";